import React from 'react';
import { styled } from '@mui/material/styles';
import PlateSearch from '../../components/PlateSearch';
import ConsultationsProof from '../../components/ConsultationsProof';
import SocialProof from '../../components/SocialProof';
import HowItWorks from '../../components/HowItWorks';
import VehicleAnalysis from '../../components/VehicleAnalysis';
import MeetOurInspections from '../../components/MeetOurInspections';
import B2bPackagesSection from '../../components/B2bPackagesSection';
import AboutUs from '../../components/AboutUs';
import OurPartners from '../../components/OurPartners';
import FaqSection from '../../components/FaqSection';
import { brandTokens } from '../theme';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: brandTokens.backgroundApp,
}));

const Section = styled('section')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const Home = () => {
  return (
    <Root>
      <Section id="plateSearch">
        <PlateSearch />
      </Section>
      <Section id="consultationsProof">
        <ConsultationsProof />
      </Section>
      <Section>
        <OurPartners />
      </Section>
      <Section id="vehicleAnalysis">
        <VehicleAnalysis />
      </Section>
      <Section id="howItWorks">
        <HowItWorks />
      </Section>
      <Section id="meetOurInspections">
        <MeetOurInspections />
      </Section>
      <Section id="b2bPackages">
        <B2bPackagesSection />
      </Section>
      <Section id="socialProof">
        <SocialProof />
      </Section>
      <Section id="faq">
        <FaqSection />
      </Section>
      <Section id="aboutUs">
        <AboutUs />
      </Section>
    </Root>
  );
};

export default Home;
